var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfImprovement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 64,
    viewBox: "0 0 72 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 16C40.4183 16 44 12.4183 44 8C44 3.58172 40.4183 0 36 0C31.5817 0 28 3.58172 28 8C28 12.4183 31.5817 16 36 16Z",
    fill: "#702F8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 48V40C63.04 40 55.36 36.16 49.6 29.28L44.24 22.88C42.72 21.04 40.48 20 38.12 20H33.92C31.56 20 29.32 21.04 27.8 22.88L22.44 29.28C16.64 36.16 8.96 40 0 40V48C11.08 48 20.76 43.32 28 35V44L12.48 50.2C9.8 51.28 8 53.92 8 56.84C8 60.8 11.2 64 15.16 64H24V62C24 56.48 28.48 52 34 52H46C47.12 52 48 52.88 48 54C48 55.12 47.12 56 46 56H34C30.68 56 28 58.68 28 62V64H56.84C60.8 64 64 60.8 64 56.84C64 53.92 62.2 51.28 59.52 50.2L44 44V35C51.24 43.32 60.92 48 72 48Z",
    fill: "#702F8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfImprovement);
export default __webpack_public_path__ + "static/media/self_improvement.c38f631fd849ea9d2741b28c8b13e66c.svg";
export { ForwardRef as ReactComponent };